import React, { Component, Fragment } from "react";
import Fade from "react-reveal";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./WhyWeDo.module.scss";

import Fact1 from "../../assets/png/Fact1.png";
import Fact2 from "../../assets/png/Fact2.png";
import Fact3 from "../../assets/png/Fact3.png";
import Fact4 from "../../assets/png/Fact4.png";
import Fact5 from "../../assets/png/Fact5.png";
import Fact6 from "../../assets/png/Fact6.png";

export default class WhyWeDo extends Component {
  render() {
    return (
      <section id={styles.WhyWeDo}>
        <Container
          className={styles.landingContainer}
          id="Facts"
          fluid
        >
          <Row>
            <Fade left>
              <Col>
                <p className={styles.containerText} id={styles.TitleText1}>
                  WHY WE DO WHAT WE DO
                </p>
                <p className={styles.containerText} id={styles.TitleText2}>
                  <i>a few undeniable facts:</i>
                </p>
              </Col>
            </Fade>
          </Row>

          <Row>
            <Col lg={6} className={styles.containerTop}>
              <Fade left>
                <div id={styles.Fact1}>
                  <p className={styles.header}>
                    <Image src={Fact1} alt="Fact1" id={styles.ImageFact1} />
                  </p>
                  <p className={styles.info}>
                    "The worst impacts of climate change could be{" "}
                    <b>irreversible by 2030."</b>
                    <br></br>— United Nations
                  </p>
                </div>

                <div id={styles.Fact2}>
                  <p className={styles.header}>
                    <Image src={Fact2} alt="Fact2" id={styles.ImageFact2} />
                  </p>
                  <p className={styles.info}>
                    "Over the <b>past 171 years,</b> human activities have
                    raised atmospheric concentrations of{" "}
                    <b>
                      CO<sub>2</sub> by 48% above pre-industrial levels
                    </b>{" "}
                    found in 1850. This is more than what had happened naturally
                    over a <b>20,000 year period</b> (from the Last Glacial
                    Maximum to 1850, from 185 ppm to 280 ppm)."
                    <br></br>— NASA
                  </p>
                </div>

                <div id={styles.Fact3}>
                  <p className={styles.header}>
                    <Image src={Fact3} alt="Fact3" id={styles.ImageFact3} />
                  </p>
                  <p className={styles.info}>
                    "The <b>20 warmest years</b> on record have been in the{" "}
                    <b>past 22 years."</b>
                    <br></br>— World Meteorological Organization (WMO)
                  </p>
                </div>
              </Fade>
            </Col>

            <Col lg={6} className={styles.containerBottom}>
              <Fade right>
                <div id={styles.Fact4}>
                  <p className={styles.header}>
                    <Image src={Fact4} alt="Fact4" id={styles.ImageFact4} />
                  </p>
                  <p className={styles.info}>
                    "More than{" "}
                    <b>1 million species are at risk of extinction</b> by
                    climate change."<br></br>— National Institute of
                    Environmental Health Sciences (NIEHS)
                  </p>
                </div>

                <div id={styles.Fact5}>
                  <p className={styles.header}>
                    <Image src={Fact5} alt="Fact5" id={styles.ImageFact5} />
                  </p>
                  <p className={styles.info}>
                    <b>"One-third of food</b> produced for human consumption is
                    lost or wasted globally, which amounts to about{" "}
                    <b>1.3 billion tonnes per year."</b>
                    <br></br>— Food and Agriculture Organization of the United
                    Nations (FAO)
                  </p>
                </div>

                <div id={styles.Fact6}>
                  <p className={styles.header}>
                    <Image src={Fact6} alt="Fact6" id={styles.ImageFact6} />
                  </p>
                  <p className={styles.info}>
                    The Food and Agriculture Organization of the United Nations
                    (FAO) has dedicated the{" "}
                    <b>
                      year 2021 to sustainable food production and reducing food
                      loss and waste,
                    </b>{" "}
                    through innovation and technology.
                  </p>
                  <p id={styles.TextGreen}>
                    <b>
                      <i>
                        Agrinol is proud and excited to pave this global effort.
                      </i>
                    </b>
                  </p>
                </div>
              </Fade>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
